import { render, staticRenderFns } from "./beneficiary_info.vue?vue&type=template&id=b81f947e&"
import script from "./beneficiary_info.vue?vue&type=script&lang=js&"
export * from "./beneficiary_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports